import React from 'react';

const SvgCi = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="CI_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="CI_svg__b" fill="#fff">
        <use xlinkHref="#CI_svg__a" />
      </mask>
      <rect
        stroke="#F5F5F5"
        strokeWidth={0.5}
        x={0.25}
        y={0.25}
        width={27.5}
        height={19.5}
        rx={2}
      />
      <path fill="#1DC87D" mask="url(#CI_svg__b)" d="M18.667 0H28v20h-9.333z" />
      <path fill="#F89242" mask="url(#CI_svg__b)" d="M0 0h9.333v20H0z" />
    </g>
  </svg>
);

export default SvgCi;
